export const MY_CATALOG = 'my-catalog';
export const AGRO_POWER = 'agro-power';